import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const {
	spacing,
	colors,
	common: { border, borderRadius },
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		background: colors.background.light,
		border,
		borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		fontSize: 14,
		gap: spacing.sm,
		justifyContent: 'space-between',
		marginTop: spacing.sm,
		padding: `${spacing.sm}px ${spacing.md}px`,
	},
	description: {
		lineHeight: 1.4,
	},
	bold: {
		fontWeight: 600,
	},
});
